<script setup>
import { RouterLink } from 'vue-router'
import { computed, ref, inject } from 'vue' // Import ref für State
import { logo } from '@/assets/brand/logo'
import { sygnet } from '@/assets/brand/sygnet'
import { AppSidebarNav } from '@/components/AppSidebarNav.js'
import { useSidebarStore } from '@/stores/sidebar.js'

const sidebar = useSidebarStore()
import smallLogo from '@/assets/images/cybrgate_small.png'
import fullLogo from '@/assets/images/CybrgateLogoWithFont.png'
const swal = inject('$swal');

// Computed property für das Sidebar-Logo
const sidebarBrandImage = computed(() =>
  sidebar.unfoldable ? smallLogo : fullLogo
)

// Superuser-Check
const isSuperuser = localStorage.getItem('isSuperuser') === 'true'

// Ladezustand für den Button
const loading = ref(false)

// Funktion für den API-Request
const importCustomCoins = async () => {
  if (loading.value) return // Falls bereits geladen wird, verhindern

  loading.value = true
  try {
    const response = await fetch(import.meta.env.VITE_API_BASE_URL+'adminpanel/import-custom-coins/')
    const result = await response.json()
    if (result.status === "success") {
      swal.fire({
          title: 'Erfolg',
          text: "Custom Coins erfolgreich importiert!",
          icon: 'success',
      });
    } else {
      swal.fire({
          title: 'Fehler',
          text: 'Fehler beim Import!.',
          icon: 'warning',
      });
    }
  } catch (error) {
    console.error("Fehler beim Import:", error)
    swal.fire({
        title: 'Fehler',
        text: 'Fehler beim Import!.',
        icon: 'warning',
    });
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <CSidebar
    class="border-end"
    colorScheme="dark"
    position="fixed"
    :unfoldable="sidebar.unfoldable"
    :visible="sidebar.visible"
    @visible-change="(value) => sidebar.toggleVisible(value)"
  >
    <CSidebarHeader class="border-bottom">
      <RouterLink custom to="/" v-slot="{ href, navigate }">
        <CSidebarBrand v-bind="$attrs" as="a" :href="href" @click="navigate" class="d-flex flex-column align-items-center text-decoration-none">
          <img 
            custom-class-name="sidebar-brand-full" 
            :src="sidebarBrandImage" 
            alt="Cybrgate Logo" 
            style="height: 28px;"
          />
          <span 
            v-if="!sidebar.unfoldable"
            class="sidebar-tagline mt-2 text-center"
            style="font-size: 0.7rem; line-height: 1.2; color: rgba(255, 255, 255, 0.7); font-weight: 300; letter-spacing: 0.5px;"
          >Crypto Market Intelligence Habitat</span>
        </CSidebarBrand>
      </RouterLink>
      <CCloseButton class="d-lg-none" dark @click="sidebar.toggleVisible()" />
    </CSidebarHeader>

    <AppSidebarNav />

    <!-- Nur anzeigen, wenn User ein Superuser ist -->
    <div v-if="isSuperuser && !sidebar.unfoldable">
      <CButton 
        class="mx-4 mb-4"
        color="outline-primary" 
        :disabled="loading" 
        @click="importCustomCoins"
      >
        <CSpinner v-if="loading" size="sm" class="me-2" color="light" />
        <span v-if="!loading" style="font-size: 14px;">Custom Coins importieren</span>
      </CButton>
    </div>

    <CSidebarFooter class="border-top d-none d-lg-flex">
      <CSidebarToggler @click="sidebar.toggleUnfoldable()" />
    </CSidebarFooter>
  </CSidebar>
</template>
